/* LIV Extensions theme scripts */
(function () {
  'use strict';

  /* Mobile menu */
  var header = document.querySelector('[data-header]');
  var toggle = document.querySelector('[data-menu-toggle]');
  if (header && toggle) {
    toggle.addEventListener('click', function () {
      var open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && header.classList.contains('is-open')) {
        header.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }

  /* Cart count */
  function updateCartCount() {
    return fetch(window.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* AJAX add to cart (falls back to normal form post without JS) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var msg = form.querySelector('[data-cart-msg]');
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    if (msg) msg.textContent = '';

    fetch(window.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'This item could not be added to your cart.');
          return data;
        });
      })
      .then(function () {
        btn.textContent = 'Added';
        if (msg) msg.innerHTML = 'Added to your cart. <a href="' + window.routes.cart + '">View cart</a>';
        return updateCartCount();
      })
      .then(function () {
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600);
      })
      .catch(function (err) {
        btn.textContent = label;
        btn.disabled = false;
        if (msg) msg.textContent = err.message;
      });
  });

  /* Product card variant select updates the price */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-card-variant]');
    if (!select) return;
    var card = select.closest('.product-card');
    var price = card && card.querySelector('[data-card-price]');
    var opt = select.options[select.selectedIndex];
    if (price && opt) price.textContent = opt.getAttribute('data-price');
  });

  /* Product page variant picker + gallery */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variants]');
    var form = root.querySelector('form[data-ajax-cart]');
    if (!dataEl || !form) return;

    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var btn = form.querySelector('[type="submit"]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-option]'));
    var thumbs = root.querySelectorAll('[data-thumb]');

    function setMainImage(src) {
      var img = root.querySelector('[data-main-image] img');
      if (!img || !src) return;
      img.removeAttribute('srcset');
      img.src = src;
      thumbs.forEach(function (t) { t.setAttribute('aria-current', String(t.getAttribute('data-src') === src)); });
    }

    function onOptionChange() {
      var selected = fieldsets.map(function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });

      if (!variant) {
        btn.disabled = true;
        btn.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      priceEl.textContent = variant.price;
      if (compareEl) compareEl.textContent = variant.compare;
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (variant.image) setMainImage(variant.image);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    fieldsets.forEach(function (fs) { fs.addEventListener('change', onOptionChange); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { setMainImage(t.getAttribute('data-src')); });
    });
  });
})();
